import styled from 'styled-components';

export const H1 = styled.h1`
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;
  padding: 0 30px;
`;

export const H2 = styled.h1`
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;
`;
